export enum ErrorBoundaryName {
  Achievements = 'Achievements',
  AllFeed = 'AllFeed',
  AllTopics = 'AllTopics',
  AnnouncementNotificationBar = 'AnnouncementNotificationBar',
  AnswersAnalytics = 'AnswersAnalytics',
  App = 'App',
  AskMeAnything = 'AskMeAnything',
  AttachableLinkFeed = 'AttachableLinkFeed',
  AudienceAnalytics = 'AudienceAnalytics',
  BookmarkFeed = 'BookmarkFeed',
  CampaignAnalytics = 'CampaignAnalytics',
  CampaignCreateModalBoundary = 'CampaignCreateModalBoundary',
  CampaignEditModalBoundary = 'CampaignEditModalBoundary',
  CampaignFeed = 'CampaignFeed',
  CampaignHeader = 'CampaignHeader',
  CampaignSidebarSponsors = 'CampaignSidebarSponsors',
  CampaignEntityBoundary = 'CampaignEntityBoundary',
  Card = 'Card',
  DirectMessagePublisher = 'DirectMessagePublisher',
  DiscoveryFeed = 'DiscoveryFeed',
  DiscoveryNetworkQuestionFeed = 'DiscoveryNetworkQuestionFeed',
  DraftFeed = 'DraftFeed',
  DraftThread = 'DraftThread',
  EditPublisher = 'EditPublisher',
  EditTeamsMeeting = 'EditTeamsMeeting',
  EventAttendeeInfoBar = 'EventAttendeeInfoBar',
  EventCard = 'EventCard',
  EventCreationModalBoundary = 'EventCreationModalBoundary',
  EventPublisher = 'EventPublisher',
  EventsDiscoveryBanner = 'EventsDiscoveryBanner',
  GroupEvents = 'GroupEvents',
  EventEditModalBoundary = 'EventEditModalBoundary',
  GroupLiveEventsBanner = 'GroupLiveEventsBanner',
  FirstRunVivaTopics = 'FirstRunVivaTopics',
  FollowedTopics = 'FollowedTopics',
  FollowNotificationsPickerButton = 'FollowNotificationsPickerButton',
  FlightControlPanel = 'FlightControlPanel',
  GlobalAnswersAnalytics = 'GlobalAnswersAnalytics',
  GroupCreateModalBoundary = 'GroupCreateModalBoundary',
  GroupEditModalBoundary = 'GroupEditModalBoundary',
  GroupFeedNoNewPostsBanner = 'GroupFeedNoNewPostsBanner',
  GroupFeed = 'GroupFeed',
  GroupHeader = 'GroupHeader',
  GroupHeaderActions = 'GroupHeaderActions',
  GroupHeaderCompact = 'GroupHeaderCompact',
  GroupInsights = 'GroupInsights',
  GroupQnAInsights = 'GroupQnAInsights',
  GroupMemberCard = 'GroupMemberCard',
  GroupPopularTopics = 'GroupPopularTopics',
  GroupSidebar = 'GroupSidebar',
  GroupSidebarEvents = 'GroupSidebarEvents',
  HomeFeed = 'HomeFeed',
  InboxFeed = 'InboxFeed',
  InboxThread = 'InboxThread',
  LeadersDiscovery = 'LeadersDiscovery',
  LeaderEmployees = 'LeaderEmployees',
  LeadersManagement = 'LeadersManagement',
  LiveEvent = 'LiveEvent',
  LiveEventHeader = 'LiveEventHeader',
  LiveEventFeed = 'LiveEventFeed',
  LiveEventSidebar = 'LiveEventSidebar',
  LivePersonaCard = 'LivePersonaCard',
  MediaLightbox = 'MediaLightbox',
  MessageAttachments = 'MessageAttachments',
  MomentsList = 'MomentsList',
  MomentsListItem = 'MomentsListItem',
  MomentsModal = 'MomentsModal',
  MomentsOnboardingModalBoundary = 'MomentsOnboardingModalBoundary',
  MomentsPlayer = 'MomentsPlayer',
  MyLeaders = 'MyLeaders',
  MyTopics = 'MyTopics',
  NavigationCommunities = 'NavigationCommunities',
  NetworkQuestion = 'NetworkQuestion',
  NetworkQuestionAdmin = 'NetworkQuestionAdmin',
  NetworkQuestionInbox = 'NetworkQuestionInbox',
  NetworkSwitcherPanel = 'NetworkSwitcherPanel',
  NotificationItem = 'NotificationItem',
  NotificationPanel = 'NotificationPanel',
  OlderReplyPaginationControls = 'OlderReplyPaginationControls',
  PersonalAnalytics = 'PersonalAnalytics',
  PinnedThreads = 'PinnedThreads',
  ProposedTopics = 'ProposedTopics',
  PublisherAttachments = 'PublisherAttachments',
  PublisherTopicsBar = 'PublisherTopicsBar',
  RealtimeSubscription = 'RealtimeSubscription',
  RealtimeConnectionEventsSubscription = 'RealtimeConnectionEventsSubscription',
  Reply = 'Reply',
  ReplyPublisher = 'ReplyPublisher',
  SearchResult = 'SearchResult',
  SearchResultsList = 'SearchResultsList',
  SharedMessage = 'SharedMessage',
  SharedMessageTile = 'SharedMessageTile',
  ShareMessagePublisher = 'ShareMessagePublisher',
  SharePointConfigurationPane = 'SharePointConfigurationPane',
  ShareTeamsMeetingPublisher = 'ShareTeamsMeetingPublisher',
  StorylineHome = 'StorylineHome',
  Stepper = 'Stepper',
  StorylineAllFeed = 'StorylineAllFeed',
  StorylineDiscoveryFeed = 'StorylineDiscoveryFeed',
  StorylineFollowedFeed = 'StorylineFollowedFeed',
  TeachingBubbleWithSoftDismiss = 'TeachingBubbleWithSoftDismiss',
  TeamsMeeting = 'TeamsMeeting',
  Thread = 'Thread',
  ThreadStarter = 'ThreadStarter',
  ThreadStarterPublisher = 'ThreadStarterPublisher',
  ThreadStarterTopicsBar = 'ThreadStarterTopicsBar',
  TopicFeatureModalBoundary = 'TopicFeatureModalBoundary',
  TopicFeed = 'TopicFeed',
  TopicNetworkQuestionFeed = 'TopicNetworkQuestionFeed',
  TopicSidebar = 'TopicSidebar',
  TrendingTopics = 'TrendingTopics',
  UserFeed = 'UserFeed',
  UserHeader = 'UserHeader',
  UserProfileCard = 'UserProfileCard',
  UserSidebar = 'UserSidebar',
  UserStorylineFeed = 'UserStorylineFeed',
  UserHeaderActions = 'UserHeaderActions',
}
